














































































































import { SpiderRepository } from '@/core/api/spiders'
import SpiderTable from './spider-table.vue'
import {
  fetchMissingPublications,
  updateMissingPublications,
  fetchMissingPublicationsTop,
  bulkCreateSourceExclusion,
} from '@/core/api/missing'
import Vue from 'vue'
import MissingPublicationFilter from './filter.vue'
import { REQUEST_ERROR, REQUEST_SUCCESS } from '@/core/events'

export default Vue.extend({
  components: {
    SpiderTable,
    MissingPublicationFilter,
  },
  data: () => ({
    loading: {
      table: false,
      top: false,
    },
    selected: [],
    items: [],
    itemsCount: 0,
    currentItem: null as any,
    filter: null as any,
    ctxMenu: {
      visible: false,
      x: 0,
      y: 0,
    },
    modalContext: {
      show: false,
      items: [],
    },
    pages: 1,
    page: 1,
    sortColumn: '',
    sortDescending: false,
    headers: [
      {
        text: 'Источник',
        value: 'source.name',
        width: '60px',
      },
      {
        text: 'URL',
        align: 'start',
        value: 'url',
        width: '250px',
      },
      {
        text: 'Заголовок',
        align: 'start',
        value: 'title',
      },
      {
        text: 'Дата',
        value: 'publish_date',
        width: '150px',
      },
      {
        text: 'Всего парсеров',
        value: 'spiders_count',
        sortable: false,
      },
      {
        text: 'Активных парсеров',
        value: 'spiders_active_count',
        sortable: false,
      },
    ],
  }),
  methods: {
    fetch() {
      this.loading.table = true
      this.currentItem = null
      fetchMissingPublications({
        page: this.page,
        pageSize: 100,
        ...this.filter,
      })
        .then(({ results, count, pages }) => {
          this.items = results
          this.itemsCount = count
          this.pages = pages
        })
        .catch(() => {
          this.$event.$emit(REQUEST_ERROR)
        })
        .finally(() => {
          this.loading.table = false
        })
    },
    getRowClass(item) {
      if (this.currentItem != null && this.currentItem['id'] === item['id']) {
        return 'blue lighten-5'
      }
    },
    async onItemDoubleClick(event: MouseEvent, data: any) {
      this.currentItem = data.item
      const { results } = await new SpiderRepository().$getPage(1, {
        source: this.currentItem.source.id,
      })
      this.modalContext.items = results
      this.modalContext.show = true
    },
    onPageChange(page: number) {
      this.page = page
      this.fetch()
    },
    onSortChange() {
      if (this.sortColumn == null || this.sortColumn === '') {
        return
      }

      this.filter.ordering = this.sortDescending ? '-' + this.sortColumn : this.sortColumn
      this.fetch()
    },
    onFilterClick() {
      this.page = 1
      this.fetch()
    },
    onFilterChange($event) {
      this.filter = $event
    },
    onSpiderClick(spider) {
      window.open(`/#/spiders/${spider.id}/edit`, '_blank')
    },
    onFixedClick() {
      updateMissingPublications(
        this.selected.map(x => x['id']),
        { status: 'FIXED' },
      ).then(() => {
        this.selected = []
        this.fetch()
      })
    },
    onExcludeSourceClick() {
      const ids = [...new Set(this.selected.map(x => x['source']['id']))]
      this.$modal
        .fire({
          title: 'Примечание',
          input: 'text',
        })
        .then(result => {
          if (result.dismiss) {
            return
          }

          bulkCreateSourceExclusion({ ids, note: result.value })
            .then(() => {
              this.$event.$emit(REQUEST_SUCCESS)
              this.selected = []
              this.fetch()
            })
            .catch(() => {
              this.$event.$emit(REQUEST_ERROR)
            })
        })
    },
    onTopClick() {
      this.loading.top = true
      fetchMissingPublicationsTop(this.filter)
        .then(({ results }) => {
          this.$modal.fire({
            title: '',
            html: results
              .map(x => `${x['name']} - ${x['count']} <br/>`)
              .slice(0, 100)
              .join(' '),
          })
        })
        .catch(() => {
          this.$event.$emit(REQUEST_ERROR)
        })
        .finally(() => {
          this.loading.top = false
        })
    },
    onContextMenu(mouseEvent: MouseEvent) {
      mouseEvent.preventDefault()

      this.ctxMenu.x = mouseEvent.x
      this.ctxMenu.y = mouseEvent.y
      this.ctxMenu.visible = true
    },
  },
})
